<div class="grid flex header-gap">
  @if (accountStatus$ | async; as orderInfo) {
    @if (orderInfo === activeOrderInfo) {
      <div class="grid w-full pb-5">
        <div class="md:col-9">
          <h1 class="header">{{ 'Order.Orders' | translate }}</h1>
          <div class="yellow-underline"></div>
        </div>
        @if (!isManager) {
          <div class="md:col-3">
            <div class="justify-content-end align-items-end flex">
              <p-button
                icon="pi pi-plus"
                label="{{ 'Order.NewOrder' | translate }}"
                styleClass="p-button-rounded"
                (onClick)="navigateToNewOrder()"
                class="p-2 pr-2" />
            </div>
          </div>
        }
      </div>

      <div class="grid w-full pb-5">
        <div class="md:col-10 pr-0">
          <div class="grid w-full">
            <div class="col">
              <div class="flex flex-column">
                <label class="input-label" for="orderId">{{ 'Order.OrderId' | translate }}</label>
                <span class="p-input-icon-right">
                  <input
                    pInputText
                    id="orderId"
                    [(ngModel)]="orderIdInput"
                    class="w-full"
                    aria-describedby="search-help"
                    pattern="[0-9]*"
                    title="Please enter only numbers" />
                </span>
              </div>
            </div>
            @if (isManager) {
              <div class="col">
                <div class="flex flex-column">
                  <label class="input-label" for="filterByPhysiciansName">{{ 'Order.Physician' | translate }}</label>
                  <span class="p-input-icon-right">
                    <p-autoComplete
                      id="filterByPhysiciansName"
                      [ngModel]="filterByPhysiciansName?.label"
                      [suggestions]="physicianFilterOptions"
                      (completeMethod)="onPhysicianAutoComplete($event)"
                      (onClear)="onPhysicianAutoComplete()"
                      (onSelect)="onPhysicianSelection($event)"
                      [maxlength]="100" />
                  </span>
                </div>
              </div>
            }
            <div class="col">
              <div class="flex flex-column">
                <label class="input-label" for="patientName">{{ 'Order.PatientName' | translate }}</label>
                <span class="p-input-icon-right">
                  <input
                    pInputText
                    id="patientName"
                    [(ngModel)]="patientNameInput"
                    class="w-full"
                    aria-describedby="search-help" />
                </span>
              </div>
            </div>
            <div class="col">
              <div class="flex flex-column">
                <label class="input-label" for="orderStatus">{{ 'Order.Status' | translate }}</label>
                <p-select
                  #orderStatusDropdown
                  id="orderStatus"
                  styleClass="w-full"
                  [options]="listOfOrderStatus"
                  optionValue="value"
                  [(ngModel)]="selOrderStatusId" />
              </div>
            </div>
            <div class="col">
              <div class="flex flex-column">
                <label class="input-label" for="dateRangePicker">{{ 'Order.CreatedDateRange' | translate }}</label>
                <p-datepicker
                  #dateRangePicker
                  id="dateRangePicker"
                  [(ngModel)]="dateRangeModel"
                  selectionMode="range"
                  [readonlyInput]="true"
                  [showOnFocus]="false"
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/YYYY - DD/MM/YYYY"
                  [showIcon]="true"
                  styleClass="w-full"
                  [maxDate]="maxSelectableDate"
                  iconDisplay="input" />
              </div>
            </div>
          </div>
        </div>
        <div class="md:col-2 pl-0 flex mt-2">
          <p-button
            icon="pi pi-times"
            pTooltip="{{ 'Order.Clear' | translate }}"
            tooltipPosition="top"
            styleClass="p-button-outlined p-button-md"
            class="p-2 pl-0"
            (onClick)="onClear()"
            [loading]="clearInProgress" />
          <p-button
            icon="pi pi-search"
            pTooltip="{{ 'Order.Search' | translate }}"
            tooltipPosition="top"
            styleClass="p-button p-button-md"
            class="p-2"
            (onClick)="onSearch(true)"
            [loading]="searchInProgress" />
        </div>
      </div>

      <div class="grid w-full pl-2 pr-2">
        @if (myOrderDetailsStatus$ | async; as state) {
          <p-table
            class="w-full"
            dataKey="id"
            [value]="orders"
            [lazy]="true"
            (onLazyLoad)="loadOrders($event)"
            (onPage)="onPageChange($event)"
            [paginator]="true"
            [rows]="pageSize"
            [first]="firstRowIndex"
            [totalRecords]="totalRecords"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="pageSizeOptions"
            [loading]="state === this.myOrderDetailsStatus"
            [sortField]="sortField"
            [sortOrder]="sortOption">
            <ng-template pTemplate="header">
              <tr>
                <th id="thCreated" pSortableColumn="created" style="width: 12.5%">
                  {{ 'Order.Created' | translate }}
                  <i
                    class="pi pl-1"
                    [class.pi-angle-up]="sortOption === eSortOption.ASC"
                    [class.pi-angle-down]="sortOption !== eSortOption.ASC"></i>
                </th>
                <th id="thConfirmed" style="width: 12.5%">
                  {{ 'Order.Confirmed' | translate }}
                </th>
                <th id="thOrderId" style="width: 12.5%">
                  {{ 'Order.OrderId' | translate }}
                </th>
                @if (isManager) {
                  <th id="thPhysician" style="width: 12.5%">
                    {{ 'Order.Physician' | translate }}
                  </th>
                }
                <th id="thPatient" style="width: 12.5%">
                  {{ 'Order.Patient' | translate }}
                </th>
                <th id="thTests" style="width: 12.5%">
                  {{ 'Order.Tests' | translate }}
                </th>
                <th id="thStatus" style="width: 12.5%">
                  {{ 'Order.Status' | translate }}
                </th>
                <th id="thOptions" style="width: 12.5%">
                  {{ 'Order.Options' | translate }}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-order>
              <tr>
                <td>{{ order.created | date: dateFormat }}</td>
                <td>
                  @if (
                    order.orderStatusId === orderStatusEnum.Confirmed ||
                    order.orderStatusId === orderStatusEnum.InProgress ||
                    order.orderStatusId === orderStatusEnum.Completed
                  ) {
                    {{ order.lastModified | date: dateFormat }}
                  }
                </td>
                <td>{{ order.id }}</td>
                @if (isManager) {
                  <td style="word-break: break-word">
                    <span class="grid-coloum-field">{{
                      (order?.customer?.firstName ?? '') + ' ' + (order?.customer?.lastName ?? '')
                    }}</span>
                    <br />
                    {{ order.customerEmail }}
                  </td>
                }
                <td>
                  <span class="grid-coloum-field">
                    {{ (order.patientFirstName ?? '') + ' ' + (order.patientLastName ?? '') }}
                  </span>
                </td>
                <td>
                  <span class="grid-coloum-field">
                    @for (item of order.orderItems; track item) {
                      @for (attr of item.orderItemAttributes; track attr) {
                        {{ attr.name }}
                      }
                    }
                  </span>
                </td>
                <td>
                  <p-tag [class]="getOrderStatusStyle(order.orderStatusId)">
                    <div class="flex align-items-center gap-2">
                      <span class="p-tag-text">{{ getOrderStatusName(order.orderStatusId) }}</span>
                    </div>
                  </p-tag>
                </td>
                <td>
                  @if (isEditable(order.orderStatusId)) {
                    <p-button
                      label="{{ 'Order.Edit' | translate }}"
                      styleClass="p-button-link-black"
                      (onClick)="editOrder(order)" />
                  }
                  @if (!isEditable(order.orderStatusId)) {
                    <p-button
                      label="{{ 'Order.View' | translate }}"
                      styleClass="p-button-link-black"
                      (onClick)="viewOrder(order)" />
                  }
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="8">{{ 'Order.NoResultsFound' | translate }}</td>
              </tr>
            </ng-template>
          </p-table>
        }
      </div>
    } @else {
      <div class="grid w-full pb-5">
        <div class="md:col-10">
          <h1 class="header">{{ 'Profile.LiteAccount' | translate }}</h1>
          <div class="yellow-underline"></div>
        </div>
        <div class="md:col-11">
          <p-message severity="info" [closable]="false">
            <div class="content-box">
              <span class="summary-txt">Info</span>
              <span> {{ 'Order.FailedToLoadOrder' | translate }}</span>
            </div>
          </p-message>
          <p-button
            label="{{ 'Order.BrowseTests' | translate }}"
            styleClass="p-button-rounded"
            (onClick)="navigateToNewOrder()" />
        </div>
      </div>
    }
  }
</div>
